
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39 20c0 10.493-8.507 19-19 19S1 30.493 1 20 9.507 1 20 1s19 8.507 19 19z","stroke":"#000","stroke-width":"2"}}),_c('path',{attrs:{"d":"M19.355 32.452c-4.355-.13-8.516-2-11.774-5.775-.646-.741-.613-1.613.032-2.193.645-.58 1.516-.452 2.161.29 2.903 3.323 6.549 4.936 10.968 4.71 3.71-.194 6.806-1.774 9.258-4.516.226-.258.516-.549.806-.71.581-.29 1.29-.064 1.71.452.42.548.387 1.29-.064 1.838-1.162 1.388-2.484 2.581-4.033 3.517-2.58 1.58-5.387 2.354-9.064 2.387zM32.323 15.452v.58c-.033.807-.646 1.42-1.42 1.42-.774 0-1.42-.613-1.484-1.388-.032-.322.033-.645-.032-.967-.064-.258-.194-.58-.387-.774-.58-.484-1.645-.484-2.258-.033-.29.194-.452.484-.42.839V16c-.032.774-.612 1.387-1.386 1.42-.742.032-1.42-.549-1.517-1.291-.29-2.226.678-4 2.645-4.742 2.065-.806 4.452-.129 5.613 1.58.484.71.646 1.291.646 2.485zM7.71 15.387c-.258-2.903 2.774-4.87 5.71-4.129 1.548.387 3.322 1.71 3.225 4.13-.032.354 0 .709-.064 1.031-.162.678-.84 1.13-1.516 1.065a1.432 1.432 0 01-1.323-1.387c0-.29-.032-.58 0-.871.032-.452-.194-.742-.58-.968-.517-.29-1.065-.322-1.646-.161-.677.193-.903.516-.903 1.226V16c-.032.839-.678 1.452-1.452 1.452-.806 0-1.451-.646-1.451-1.484-.033-.194 0-.387 0-.58z","fill":"#000"}})])
          )
        }
      }
    